"use client";

import { SessionProvider } from "next-auth/react";
import { ReactNode } from "react";
import NoSSR from "../NoSSR";

interface SessionWrapperProps {
  children: ReactNode;
}

export default function SessionWrapper({ children }: SessionWrapperProps) {
  return (
    <NoSSR>
      <SessionProvider>{children}</SessionProvider>
    </NoSSR>
  );
}
